module.exports = __webpack_public_path__ + "img/id-wrong-unreadable.9c5e2cb0.png";